import { Box } from '@factorialco/deprecated-design-system'
import { F0Checkbox } from '@factorialco/f0-react'

import { observer } from 'mobx-react'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { useHover } from 'modules/core/lib/hoverContext'

import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import {
  useSelectionDispatch,
  useSelectionState,
} from 'modules/shift_management/hooks/useSelection'
import type { ShiftsRow } from 'modules/shift_management/lib/types'

interface Props {
  shiftsRow: ShiftsRow
}

const ShiftsRowCheckbox = ({ shiftsRow }: Props) => {
  const hover = useHover()

  const { rowsSelected, isEnabled } = useSelectionState()
  const dispatchSelection = useSelectionDispatch()
  const [{ view }] = useSchedule()
  const [{ hasFeatureFlag }] = useEnabledFeatures()

  const canManage = shiftsRow.canManage
  const rowSelectedSet = new Set(rowsSelected)

  const isChecked = rowSelectedSet.has(shiftsRow.key)
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')
  const showCheckbox = newEntryFlowEnabled ? isChecked : isEnabled
  const isCheckboxEnabled = canManage && !view.isDaily && (hover || showCheckbox)

  const onSelect = () => {
    track(trackingEvents.shiftManagement.bulkEmployeePeriodSelected, {
      selected: !isChecked,
      view: view.viewType,
      view_type_by: view.groupType,
    })

    dispatchSelection({
      type: 'TOGGLE_SHIFTS_ROW',
      shiftsRow,
      view: view,
    })
  }

  return (
    <Box style={{ visibility: isCheckboxEnabled ? 'visible' : 'hidden' }} onClick={onSelect}>
      <F0Checkbox checked={isChecked} />
    </Box>
  )
}

export default observer(ShiftsRowCheckbox)
